import React from 'react'
import { useTheme } from '../../../../Utils/useTheme'
import { PaginationSpec } from '../types'

export const TableFooter = ({
  totalRows,
  pagination,
  onChange
}: {
  totalRows: number
  pagination: PaginationSpec
  onChange: (p: PaginationSpec) => void
}) => {
  const { border, text, hover } = useTheme()

  const from = totalRows === 0 ? 0 : pagination.page * pagination.pageSize + 1
  const to = Math.min(totalRows, (pagination.page + 1) * pagination.pageSize)
  const maxPage = totalRows === 0 ? 0 : Math.max(0, Math.ceil(totalRows / pagination.pageSize) - 1)

  const btnStyle: React.CSSProperties = {
    width: 32,
    height: 32,
    borderRadius: 12,
    border: `1px solid ${border}`,
    background: 'rgba(17,24,39,0.06)',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }

  return (
    <div
      style={{
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 12px',
        background: 'rgba(255,255,255,0.92)',
        borderTop: `1px solid ${border}`,
        color: text,
        fontSize: 12
      }}
    >
      <div style={{ opacity: 0.9, fontWeight: 600 }}>
        {from}-{to} of {totalRows}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div
            style={{ ...btnStyle, opacity: pagination.page <= 0 ? 0.35 : 1, pointerEvents: pagination.page <= 0 ? 'none' : 'auto' }}
            onMouseEnter={e => (e.currentTarget.style.background = hover)}
            onMouseLeave={e => (e.currentTarget.style.background = 'rgba(17,24,39,0.06)')}
            onClick={() => onChange({ ...pagination, page: Math.max(0, pagination.page - 1) })}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div
            style={{ ...btnStyle, opacity: pagination.page >= maxPage ? 0.35 : 1, pointerEvents: pagination.page >= maxPage ? 'none' : 'auto' }}
            onMouseEnter={e => (e.currentTarget.style.background = hover)}
            onMouseLeave={e => (e.currentTarget.style.background = 'rgba(17,24,39,0.06)')}
            onClick={() => onChange({ ...pagination, page: Math.min(maxPage, pagination.page + 1) })}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <div style={{ opacity: 0.65, fontWeight: 600 }}>
          Page {pagination.page + 1}/{maxPage + 1}
        </div>

        <select
          value={pagination.pageSize}
          onChange={(e) => onChange({ page: 0, pageSize: Number(e.target.value) })}
          style={{
            height: 34,
            borderRadius: 12,
            border: `1px solid ${border}`,
            background: 'rgba(255,255,255,0.86)',
            color: '#0b1220',
            padding: '0 10px',
            outline: 'none',
            fontSize: 12,
            fontWeight: 600
          }}
        >
          {[10, 25, 50, 100].map(n => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
